<template>
  <div class="automation">
    <div style="margin-bottom: 10px">
      <el-button style="float: left" @click="goBack" type="primary"
        ><i class="fas fa-arrow-left"></i> Go Back</el-button
      >
      <el-button @click="openModal('new')" type="primary" style="float: right"
        >+ Add new Notice Template</el-button
      >
    </div>
    <div style="clear: both"></div>
    <hr style="margin-top: 10px" />
    <el-table
      :data="data"
      style="width: 100%"
      :default-sort="{ prop: 'created_at', order: 'ascending' }"
      v-loading="loading"
    >
      <!-- <el-table-column prop="when" label="Actions" sortable>
        <template slot-scope="scope">
          <div :key="action.id" v-for="action in scope.row.actions">
            <small>{{ child }}</small>
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="parent" label="Parent" sortable></el-table-column> -->
      <el-table-column prop="id" label="ID" sortable></el-table-column>
      <el-table-column
        prop="template_title"
        label="Template Title"
        sortable
      ></el-table-column>
      <el-table-column
        prop="category"
        label="Category"
        sortable
      ></el-table-column>
      <el-table-column label="Type" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.template_type == 1">Static</span>
          <span v-if="scope.row.template_type == 2">School level</span>
          <span v-if="scope.row.template_type == 3">User level</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="Created"
        sortable
      ></el-table-column>
      <el-table-column
        prop="updated_at"
        label="Updated"
        sortable
      ></el-table-column>
      <el-table-column label="Actions">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            title="Edit"
            @click="openModal(scope.row.id)"
            ><i class="fa-solid fa-pen-to-square"></i>
          </el-button>
          <!-- <el-button
            size="mini"
            type="warning"
            title="Duplicate"
            @click="action('duplicate', scope.row.id)"
            ><i class="fa-solid fa-copy"></i>
          </el-button> -->
          <el-popconfirm
            title="Are you sure you want to delete it?"
            @confirm="deleteNotice(scope.row.id)"
            class="ml-10px"
          >
            <el-button slot="reference" size="mini" type="danger"
              ><i class="fas fa-trash"></i
            ></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import CreatePost from "@/views/CreatePost.vue";
import ApiService from "@/services/ApiService";
export default {
  name: "NoticesTemplates",
  data() {
    return {
      data: [
        // {
        //   id: 1,
        //   name: "Test template",
        //   description: "It should do this and that",
        //   created_at: "May 5th, 22",
        //   edited_at: "May 5th, 22",
        // },
      ],
      loading: false,
    };
  },
  methods: {
    goBack() {
      this.$router.push("/members/automations");
    },
    goto(path) {
      path = "actions/" + path;
      this.$router.push(path);
    },
    openModal(id) {
      this.$modal.show(
        CreatePost,
        {
          id,
          isTemplate: true,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          width: 1000,
          height: "auto",
          adaptive: true,
        },
        {
          "before-close": this.getTemplates,
        }
      );
    },
    deleteNotice(id) {
      ApiService.automationsApi
        .deleteItem("noticeTemplate", id)
        .then((resp) => {
          if (resp.data === "automation_uses_this_template") {
            this.$notify.info({
              title: "Deleted",
              message: "One ore more automations used this template.!",
            });
          } else {
            this.$notify.info({
              title: "Deleted",
              message: "Deleted!",
            });
          }

          this.getTemplates();
        });
    },
    action(type, id) {
      if (type === "edit") {
        this.$router.push("/members/edit-email-template/" + id);
      }
    },
    getTemplates() {
      ApiService.automationsApi.getTemplates("notices").then((resp) => {
        this.data = resp.data;
      });
    },
  },
  mounted() {
    this.getTemplates();
  },
};
</script>
